module.exports = __webpack_public_path__ + "img/contract-sample.33073a8f.svg";